import {
  registerDataTableComponent,
  registerCustomDetailComponent,
} from "@bb-vendure/admin-ui/core";
import { TotalLinksCell } from "./components/TotalLinkCell";
import { ArtistNameCell } from "./components/ArtistNameCell";
import { ProductNameComponent } from "./components/product-name/product-name.component";
import { ProductFacetsColumnComponent } from "./components/product-facets-column/product-facets-column.component";

export default [
  registerDataTableComponent({
    tableId: "product-list",
    columnId: "totalLinks",
    component: TotalLinksCell,
  }),
  registerDataTableComponent({
    tableId: "product-list",
    columnId: "artistName",
    component: ArtistNameCell,
  }),

  registerDataTableComponent({
    component: ProductNameComponent,
    tableId: "product-list",
    columnId: "name",
  }),

  registerDataTableComponent({
    component: ProductFacetsColumnComponent,
    tableId: "product-list",
    columnId: 'facetsColumn',
  }),
];
